(function(){
  function cop(c){ return '$ ' + Math.round(c/100).toLocaleString('es-CO'); }
  document.querySelectorAll('.cj[data-cj]').forEach(function(card){
    var datos;
    try { datos = JSON.parse(card.getAttribute('data-cj')); } catch(e){ return; }
    var prendas = [datos.a, datos.b];
    var sel = prendas.map(function(p){ return new Array(p.opts).fill(null); });
    var btn = card.querySelector('.cj-add');
    var totalEl = card.querySelector('.cj-total');
    function variante(pi){
      return prendas[pi].vars.find(function(v){
        return v.o.every(function(x,i){ return sel[pi][i] === x; });
      }) || null;
    }
    function compatible(pi, gi, val){
      return prendas[pi].vars.some(function(v){
        if (!v.av || v.o[gi] !== val) return false;
        return v.o.every(function(x,i){ return i === gi || sel[pi][i] === null || sel[pi][i] === x; });
      });
    }
    function pinta(){
      card.querySelectorAll('.cj-chip').forEach(function(ch){
        var pi = +ch.getAttribute('data-p'), gi = +ch.getAttribute('data-g'), val = ch.getAttribute('data-v');
        ch.classList.toggle('on', sel[pi][gi] === val);
        ch.classList.toggle('no', !compatible(pi, gi, val));
      });
      var va = variante(0), vb = variante(1);
      var listo = va && va.av && vb && vb.av;
      btn.disabled = !listo;
      btn.textContent = listo ? 'Agregar conjunto al carrito' : 'Elige tallas para armar el conjunto';
      var t = (va ? va.p : prendas[0].vars[0].p) + (vb ? vb.p : prendas[1].vars[0].p);
      totalEl.innerHTML = 'Conjunto: ' + cop(t) + ' <small>COP</small>';
    }
    card.addEventListener('click', function(e){
      var ch = e.target.closest('.cj-chip');
      if (!ch) return;
      var pi = +ch.getAttribute('data-p'), gi = +ch.getAttribute('data-g'), val = ch.getAttribute('data-v');
      sel[pi][gi] = (sel[pi][gi] === val) ? null : val;
      pinta();
    });
    btn.addEventListener('click', function(){
      var va = variante(0), vb = variante(1);
      if (!va || !vb || !va.av || !vb.av) return;
      [[prendas[0], va], [prendas[1], vb]].forEach(function(par){
        window.succoCart.add({
          variantId: par[1].id, handle: par[0].handle, nombre: par[0].nombre,
          variante: par[1].o.join(' / '), precio: par[1].p, foto: par[0].foto,
          qty: 1, ref: par[0].ref, moda: true
        });
      });
      btn.classList.add('ok');
      btn.textContent = '✓ Conjunto en el carrito';
      setTimeout(function(){
        btn.classList.remove('ok');
        pinta();
        window.location.href = '/cart';
      }, 900);
    });
    pinta();
  });
})();
